import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { UserDocument as UserDocumentIcon } from 'components/icons'

type Props = IconProps

const UserDocument: FC<Props> = (props) => {
  return <UserDocumentIcon {...props} />
}

const UserDocumentExports = {
  UserDocument,
}

export default UserDocumentExports
